import { utils } from '@deeptrue-frontend/ui';
import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';

import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';
import ReactDOMServer from 'react-dom/server';

export const registerHtmlnew = () => {
  const Html = utils.survey.widgets.html.widget;

  class QuestionHtmlnewModel extends Question {
    getType() {
      return 'dthtml';
    }
    get dthtmlType() {
      return this.getPropertyValue('dthtmlType');
    }
    set dthtmlType(val) {
      this.setPropertyValue('dthtmlType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dthtml = 'dt HTML';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dthtml', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dthtml',
    [
      {
        name: 'dthtmlType',
      },
    ],
    function () {
      return new QuestionHtmlnewModel('');
    },
    'question'
  );

  SurveyQuestionEditorDefinition.definition.dthtml = {
    properties: [{ name: 'dthtmlType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dthtml', (name) => {
    return new QuestionHtmlnewModel(name);
  });

  class SurveyQuestionHtmlnew extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore
      return this.question.dthtmlType;
    }
    handleHtmlnewChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return <Html question={this.question} />;
    }
  }
  ReactQuestionFactory.Instance.registerQuestion('dthtml', (props: any) => {
    return React.createElement(SurveyQuestionHtmlnew, props);
  });

  Serializer.addProperties('dthtml', [
    {
      name: 'htmlText:html',
      default: '<span>Enter your html code </span>',
      isLocalizable: true,
      category: 'general',
      visibleIndex: 4,
    },
  ]);

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dthtml';
    },
    getJSON: function () {
      return { type: 'dthtml' };
    },
  });
};
